import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, wide = false, testId }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-ink/50 flex items-start justify-center overflow-y-auto py-10 px-4" onClick={onClose} data-testid={testId}>
      <div className={`bg-linen border border-ink/15 w-full ${wide ? "max-w-3xl" : "max-w-lg"} my-auto`} onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center px-6 py-4 border-b border-ink/10">
          <h3 className="font-heading text-2xl">{title}</h3>
          <button onClick={onClose} className="icon-thin" data-testid="modal-close"><X size={20} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
